import { useState, useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { fetchActiveEvent } from '../lib/api';

/**
 * Resolves the active event and redirects to its kiosk board.
 * Preserves query string (e.g. ?room=Main Hall).
 */
export function ActiveEventKioskRedirect() {
  const [searchParams] = useSearchParams();
  const [activeEventId, setActiveEventId] = useState<string | null | 'loading'>('loading');

  useEffect(() => {
    fetchActiveEvent().then((ev) => {
      setActiveEventId(ev?.id ?? null);
    });
  }, []);

  const query = searchParams.toString();

  if (activeEventId === 'loading') {
    return (
      <div className="kiosk-board-page flex items-center justify-center">
        <div className="inline-block w-10 h-10 border-4 border-primary-200 border-t-primary-400 rounded-full animate-spin" />
      </div>
    );
  }

  if (activeEventId) {
    const suffix = query ? `?${query}` : '';
    return <Navigate to={`/event/${activeEventId}/kiosk${suffix}`} replace />;
  }

  return (
    <div className="kiosk-board-page flex items-center justify-center p-8">
      <p className="text-gray-500 text-center">
        No event is currently active.
      </p>
    </div>
  );
}
